// extracted by mini-css-extract-plugin
export default {"isLowInStock":"ejYnh","isLooks":"nwKlO","lowInStockMessage":"BG5dl","icon":"ilKJ9"};